<template>
  <ProSpaceVLayout class="home-dashboard-item" align-items="center" :gap="5">
    <div class="home-dashboard-item__count text-color-main text-size-21 text-bolder">
        {{ formatDigit(count, null, 0) || 0 }}
    </div>
    <div class="home-dashboard-item__label text-color-gray text-size-12 text-align-center">
        {{ label }}
    </div>
  </ProSpaceVLayout>
</template>

<script>
import {
  ProSpaceVLayout,
} from "@prospace/prospace-components-library";
import formatDigit from "@prospace/prospace-components-library/src/lib-assets/mixins/digitFormatter";
export default {
  name: "HomeDashboardItem",
  components: {
    ProSpaceVLayout
  },
  props: {
    label: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      required: true
    }
  },
  methods: {
    formatDigit
  }
}
</script>

<style lang="scss">
.home-dashboard-item {
    padding: 10px;
    border-radius: 5px;
    background: var(--prospace-ui-bg);
    &__label {
        white-space: break-spaces;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
    }
}
</style>
